module.exports = __webpack_public_path__ + "assets/img/14_930.3bb61cd0.jpg";